import { render, staticRenderFns } from "./LargeSizeScreen.vue?vue&type=template&id=1032c229&scoped=true&"
import script from "./LargeSizeScreen.vue?vue&type=script&lang=js&"
export * from "./LargeSizeScreen.vue?vue&type=script&lang=js&"
import style0 from "./LargeSizeScreen.vue?vue&type=style&index=0&id=1032c229&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032c229",
  null
  
)

export default component.exports